@if (authService.authenticated()) {
  <p-menubar [model]="menuItems()">
    <ng-template #start>
      <span class="font-bold text-xl mr-4 text-primary">wd-im.de</span>
    </ng-template>
    <ng-template #end>
      <div class="flex items-center gap-3">
        <p-avatar
          [label]="authService.userProfile()?.username?.charAt(0)?.toUpperCase() ?? '?'"
          shape="circle"
          size="normal"
        />
        <span class="text-sm text-surface-500">
          {{ authService.userProfile()?.username }}
        </span>
        <p-button
          label="Abmelden"
          icon="pi pi-sign-out"
          severity="secondary"
          [text]="true"
          size="small"
          (onClick)="authService.logout()"
        />
      </div>
    </ng-template>
  </p-menubar>
}

<router-outlet />
